<template>
	<v-dialog
		v-model="dialog"
		max-width="960px"
		scrollable>

		<div v-shortkey="['esc']" @shortkey="dialog = false"></div>

		<template v-slot:activator="{ on }">
			<v-btn
				flat icon
				class="ma-0"
				v-on="on"
				color="green accent-3"
				title="Contacter le support">
				<v-icon size="25">contact_support</v-icon>
			</v-btn>
		</template>

		<v-card class="background">
			<v-card-title class="py-1 background darken-1 ">
				<span>
					<div class="headline">
						Support Gravity
					</div>
					<div class="font-italic">
						Veuillez préciser votre demande
					</div>
				</span>
				<v-spacer></v-spacer>
				<v-btn large icon flat class="ma-0 ml-5" @click="dialog = false">
					<v-icon large>close</v-icon>
				</v-btn>
			</v-card-title>
			<v-card-text class="pt-2">
				<span class="subheading">Sujet</span>
				<v-text-field
					solo
					hide-details
					class="inputs mb-2"
					v-model="title">
				</v-text-field>
				<span class="subheading">Description</span>
				<v-textarea
					solo
					hide-details
					class="inputs mb-2"
					:rows="5"
					auto-grow
					v-model="what">
				</v-textarea>
				<span class="subheading">Pièces jointes</span>
				<Attachment
					v-if="dialog"
					:items="attachments"
					@add="addAttachment($event)"
					@delete="removeAttachment($event)">
				</Attachment>
			</v-card-text>
			<v-card-actions>
				<v-btn
					color="background darken-1"
					class="text-none"
					@click="dialog = false">
					Annuler
				</v-btn>
				<v-btn
					flat
					color="warning"
					class="text-none"
					v-if="Object.keys(attachments).length > 0"
					@click="attachments = {}">
					Supprimer les pièces jointes
				</v-btn>
				<v-spacer></v-spacer>
				<v-btn
					color="primary color--text"
					class="text-none"
					:loading="loading"
					:disabled="disabled"
					@click="sendTicket()">
					Envoyer
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import Attachment from '@/pages/about/ticket_form_attachment.vue'
import axios from 'axios'
export default {
	components: { Attachment },
	data () {
		return {
			dialog: false,
			loading: false,
			title: '',
			what: '',
			specific_payload: null,
			attachments: {}
		}
	},
	computed: {
		disabled () {
			return !this.title || !this.what
		}
	},
	watch: {
		dialog (val) {
			this.specific_payload = null
			if (val) {
				this.$Bus.$emit('get_support_payload')
			}
		}
	},
	methods: {
		addAttachment (attachment) {
			this.$set(this.attachments, attachment.name, attachment)
			this.$forceUpdate()
		},
		removeAttachment (attachment) {
			this.$delete(this.attachments, attachment)
		},
		uploadFile (item, ticket_id) {
			return new Promise((resolve, reject) => {
				let formData = new FormData()
				formData.append('path', item.file)
				formData.append('label', item.name)
				formData.append('ticket', `/api/ticket/${ticket_id}/`)
				let user = this.$store.getters.user
				const config = {
					headers: {
						Authorization: `Token ${user.maestroAuth}`
					},
					onUploadProgress: progressEvent => {
						if (progressEvent.isTrusted && progressEvent.lengthComputable) {
							let progress = Math.floor(
								progressEvent.loaded / progressEvent.total * 100
							)
							this.attachments[item.name].progress = progress
						}
					}
				}
				let url = `${window.appConfig._$5u7vw2}api/ticket/${ticket_id}/attachment/`
				axios.post(url, formData, config)
					.then(response => {
						resolve(response.data)
					})
					.catch(error => {
						console.error('fileUpload error', error.response)
						reject(error)
					})
			})
		},
		sendTicket () {
			let payload = []
			payload.push({ name: 'route',
				items: [
					{ key: 'name', value: this.$route.name },
					{ key: 'url', value: window.appConfig._$92sql3 + this.$route.fullPath }
				]
			})
			let jrId = this.$route.params.jr_id || this.$route.query.jr_id || null
			if (jrId) {
				payload.push({ name: 'JR Maestro',
					items: [
						{
							key: 'url',
							value: `${window.appConfig._$5u7vw2}requests/${jrId}/`
						}
					]
				})
			}
			payload.push({ name: 'status',
				items: [
					{ key: 'api_nexus', value: this.$store.getters.nexus_api_status },
					{ key: 'fileopener', value: this.$store.getters.fileopener_status },
					{ key: 'api_maestro', value: this.$store.getters.maestro_api_status },
					{ key: 'es_maestro', value: this.$store.getters.maestro_es_status }
				]
			})
			payload.push({ name: 'env',
				items: [
					{ key: 'env', value: window.appConfig._$ppt9qr },
					{ key: 'user_agent', value: window.navigator.userAgent }
				]
			})
			for (const key in this.specific_payload) {
				payload.push({ name: key,
					items: Object.entries(this.specific_payload[key]).map(item => {
						return {
							key: item[0],
							value: item[1]
						}
					})
				})
			}
			this.loading = true
			this.$ApiMaestro.post_ticket(this.title, this.what, payload)
				.then(async (result) => {
					if (result.data.created) {
						for (const key in this.attachments) {
							let item = this.attachments[key]
							if (item.block_reasons.length > 0) continue
							if (item.uploading) continue
							if (item.done) continue
							try {
								item.uploading = true
								item.error = false
								await this.uploadFile(item, result.data.created)
								item.uploading = false
								item.done = true
							} catch (error) {
								console.log('upload error', error)
								item.progress = 0
								item.done = false
								item.uploading = false
								let errorMessage = error
								if (error.hasOwnProperty('response')) {
									if (typeof error.response.data === 'object') {
										for (const key in error.response.data) {
											errorMessage += '<br />'
											errorMessage += error.response.data[key]
										}
									}
								}
								item.error = errorMessage
							}
						}
						if (result.data.reference) {
							let ticketRoute = this.$router.resolve({
								name: 'Ticket',
								params: {
									ref: result.data.reference
								}
							})
							setTimeout(() => {
								window.open(ticketRoute.href, '_blank')
							}, 1000)
						}
						this.$EventDialer('success', false, 'Ticket lancé', null, 2000)
						this.loading = false
						this.title = ''
						this.what = ''
						this.dialog = false
						this.attachments = {}
					}
				})
				.catch(error => {
					this.loading = false
					this.$EventDialer(
						'error',
						false,
						'Erreur',
						JSON.stringify(error.response.data, null, 2),
						0
					)
					console.error(error.response)
				})
		},
		setSpecificPayload (payload) {
			if (this.dialog) {
				this.specific_payload = {...this.specific_payload, ...payload}
			}
		}
	},
	mounted () {
		this.$Bus.$on('set_support_payload', this.setSpecificPayload)
	},
	destroyed () {
		this.$Bus.$off('set_support_payload', this.setSpecificPayload)
	}
}
</script>

<style lang="stylus" scoped>
.inputs
	>>>.v-input__slot
		background-color: var(--v-background-darken1) !important
		border: 1px solid var(--v-background-lighten1)
	>>>textarea
		margin-top: 8px !important
</style>



// WEBPACK FOOTER //
// src/pages/about/ticket_form.vue